import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import clsx from 'clsx';
import { LinkIcon } from 'lucide-react';
import { Link } from 'next-view-transitions';
import React from 'react';

import { renderTextWithMarks } from '@/app/components/ui/RichText/Configs/renderTextMarks';
import { cn } from '@/app/lib/utils/cn';

const renderTable = (node: any, locationData?: string): React.ReactNode => {
  return (
    <div className="col-span-full overflow-x-auto rounded-xl py-5">
      <table className="w-full min-w-full border-collapse text-left">
        <tbody>
          {node.content.map((row: any, rowIndex: number) => {
            const isHeaderRow = row.content[0]?.nodeType === 'table-header-cell';
            return (
              <tr
                key={`row-${rowIndex}`}
                className={clsx(
                  'border-b border-GREEN-500/20',
                  isHeaderRow ? 'bg-SLATE_BLUE/65' : rowIndex % 2 === 0 ? 'bg-SLATE_BLUE/25' : 'bg-transparent',
                )}
              >
                {row.content.map((cell: any, cellIndex: number) => {
                  const Tag = isHeaderRow ? 'th' : 'td';
                  return (
                    <Tag
                      key={`cell-${rowIndex}-${cellIndex}`}
                      className={cn(
                        'p-3 text-RichText-Body font-normal text-WHITE/90 md:text-Body-Large sm:text-Body',
                        isHeaderRow ? 'font-extrabold text-PURP/75' : '',
                      )}
                    >
                      {cell.content.map((paragraph: any, paragraphIndex: number) => {
                        if (paragraph.nodeType === BLOCKS.PARAGRAPH) {
                          return (
                            <React.Fragment key={`p-${rowIndex}-${cellIndex}-${paragraphIndex}`}>
                              {paragraph.content.map((item: any, itemIndex: number) => (
                                <React.Fragment key={`item-${rowIndex}-${cellIndex}-${paragraphIndex}-${itemIndex}`}>
                                  {item.nodeType === INLINES.HYPERLINK ? (
                                    <Link
                                      href={item.data.uri}
                                      target="_blank"
                                      className="text-PURP/75 underline transition-all duration-300 hover:text-BLUE-400/80 focus:text-BLUE-400/80 active:text-GREEN-500/60"
                                    >
                                      {item.content[0].value}
                                      <LinkIcon className="ml-1 inline-block h-2 w-2" />
                                    </Link>
                                  ) : (
                                    renderTextWithMarks(item, locationData)
                                  )}
                                </React.Fragment>
                              ))}
                            </React.Fragment>
                          );
                        }
                        return null;
                      })}
                    </Tag>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export { renderTable };
